export const isEmptyArray = <T>(predictable: T[]): predictable is never => {
  return predictable.length === 0;
};
